export const isContentRecord = (
    value: unknown
): value is Record<string, unknown> =>
    value !== null && typeof value === 'object' && !Array.isArray(value)

const invalidContent = () => new Error('Invalid CMS detail response')

const apiData = (body: unknown): unknown => {
    if (body == null) return null
    if (!isContentRecord(body) || !('data' in body)) throw invalidContent()
    return body.data
}

const attributesOf = (entity: unknown): Record<string, unknown> => {
    if (!isContentRecord(entity) || !isContentRecord(entity.attributes)) {
        throw invalidContent()
    }
    return entity.attributes
}

const text = (value: unknown): string => {
    if (value == null) return ''
    if (typeof value !== 'string') throw invalidContent()
    return value
}

const title = (value: unknown): string => {
    const result = text(value)
    if (!result.trim()) throw invalidContent()
    return result
}

const imageOf = (value: unknown) => {
    const data = isContentRecord(value) ? value.data : null
    const attributes = isContentRecord(data) ? data.attributes : null
    return {
        url:
            isContentRecord(attributes) && typeof attributes.url === 'string'
                ? attributes.url
                : '',
        alternativeText:
            isContentRecord(attributes) &&
            typeof attributes.alternativeText === 'string'
                ? attributes.alternativeText
                : '',
    }
}

export const parseExpertiseHeader = (body: unknown) => {
    const collection = apiData(body)
    if (collection == null) return null
    if (!Array.isArray(collection)) throw invalidContent()
    if (collection.length === 0) return null
    const attributes = attributesOf(collection[0])
    return {
        title: title(attributes.title),
        blockText1: text(attributes.blockText1),
        blockText2: text(attributes.blockText2),
        title2: text(attributes.title2),
        urlSlug: text(attributes.urlSlug),
        image: imageOf(attributes.image),
    }
}

export const parseBlogDetail = (body: unknown) => {
    const entity = apiData(body)
    if (entity == null) return null
    const detail = attributesOf(entity).detail
    if (detail == null) return null
    if (!isContentRecord(detail)) throw invalidContent()
    return {
        title: title(detail.title),
        content: text(detail.content),
        image: imageOf(detail.image),
    }
}
